import React, {useState} from 'react';
import {Formik, Field, FormikProps, FormikHelpers} from 'formik';
import classNames from 'classnames';

import {Form, Button, Layouts, Modal} from '@components';
import constants from '@constants';
import utils from '@utils';
import {Props} from './types';
import * as handlers from './handlers';
import * as hooks from './hooks';

import './index.scss';

const Safety: React.FC<Props> = props => {
  const query = utils.queryParams.parse(props.location.search);
  const isAuthed = !!props.me.id;
  const initialValues = {
    injuryStatus: constants.INJURY_STATUS.SAFETY,
    message: '',
    userNotificationId: query.id,
  };
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  hooks.useMount(props);

  return (
    <div className={classNames('a__safety-main', {after: isAuthed})}>
      {!isAuthed && (
        <div className="b__header">
          <Layouts.Header.Before
            location={props.location}
            history={props.history}
          />
        </div>
      )}
      <div className="b__title">安否状況の報告</div>
      <Formik
        initialValues={initialValues}
        onSubmit={(values: any, formikHelpers: FormikHelpers<any>) =>
          handlers.submit(
            values.injuryStatus,
            values.message,
            values.userNotificationId,
            formikHelpers,
            props.history
          )
        }
      >
        {(formProps: FormikProps<any>) => {
          return (
            <div className="b__safety-body">
              <div className="w__body-header">
                <div className="w__text">
                  <Form.Label text="送信者" />
                  <div className="b__text">
                    {props.notifications.detail.sender
                      ? `${props.notifications.detail.sender}`
                      : '-'}
                  </div>
                </div>
                <div className="w__text">
                  <Form.Label text="メッセージ" />
                  <div className="b__text">
                    {props.notifications.detail.message
                      ? `${props.notifications.detail.message}`
                      : '-'}
                  </div>
                </div>
              </div>
              <Form.Label text="怪我はありませんか？" />
              <div className="w__radio-form">
                <Field
                  component={Form.Radio}
                  label="無事"
                  name="injuryStatus"
                  value={constants.INJURY_STATUS.SAFETY}
                />
                <Field
                  component={Form.Radio}
                  label="軽傷"
                  name="injuryStatus"
                  value={constants.INJURY_STATUS.MINOR_INJURY}
                />
                <Field
                  component={Form.Radio}
                  label="重傷"
                  name="injuryStatus"
                  value={constants.INJURY_STATUS.SERIOUS_INJURY}
                />
              </div>
              <div className="w__message">
                <Form.Label text="何か連絡事項がありましたら記入してください。" />
                <Field
                  component={Form.TextArea}
                  name="message"
                  color="white"
                  placeholder="連絡事項"
                />
              </div>
              <div className="w__button">
                <Button.Normal
                  text="回答する"
                  color="yellow"
                  rounded
                  onClick={() => formProps.handleSubmit()}
                  disabled={formProps.isSubmitting}
                  loading={formProps.isSubmitting}
                />
              </div>
              {handlers.getMailType(query) ? null : (
                <div className="w__bounce-link">
                  この通知に覚えのない方は
                  <a type="button" onClick={() => setIsModal(true)}>
                    こちら
                  </a>
                  から
                </div>
              )}

              <Modal.Delete
                isModal={isModal}
                handleCloseModal={setIsModal}
                title="迷惑通知の報告"
                confirmText="報告する"
                message="迷惑通知を報告します。よろしいですか？"
                onClick={() =>
                  handlers.submitStopMail(query, setIsModal, setIsLoading)
                }
                size="responsive"
                loading={isLoading}
              />
            </div>
          );
        }}
      </Formik>
      {!isAuthed && <Layouts.Footer.Main />}
    </div>
  );
};

export default Safety;
